import script from "./Notifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=a2848ce0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2848ce0"]])

export default __exports__